import React from "react";
import { Modal, Box, Typography, Button } from "@mui/material";

const ViewQuestionData = ({ open, handleClose, data }) => {
  // console.log("View", data);

  if (!data) return null;

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "80vw",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          maxHeight: "80vh",
          overflowY: "auto",
        }}
      >
        <Typography variant="h5" sx={{ mb: 2 }}>
          Question Details
        </Typography>

        {/* Other Details */}
        <Typography sx={{ mt: 2 }}>
          ⏳ Duration: {data.duration} seconds
        </Typography>
        <Typography>📚 Module: {data.module_name}</Typography>
        <Typography>🏫 Class: {data.name}</Typography>
        <Typography>🏷️ Tags: {data.tags}</Typography>

        {/* Question */}
        <Typography variant="h6" sx={{ mt: 2 }}>
          Question:
        </Typography>
        <Typography>
          🇬🇧 English:{" "}
          {data.question_type === 1
            ? data.question_type_text_english
            : data.question_type === 2
            ? data.question_type_link_english
            : data.question_type_text_english +
              "\n" +
              data.question_type_link_english}
        </Typography>
        {data.question_type_text_hindi && (
          <Typography>
            🇮🇳 Hindi:{" "}
            {data.question_type === 1
              ? data.question_type_text_hindi
              : data.question_type === 2
              ? data.question_type_link_hindi
              : data.question_type_text_hindi +
                "\n" +
                data.question_type_link_hindi}
          </Typography>
        )}
        {data.question_type_text_marathi && (
          <Typography>
            🇮🇳 Marathi:{" "}
            {data.question_type === 1
              ? data.question_type_text_marathi
              : data.question_type === 2
              ? data.question_type_link_marathi
              : data.question_type_text_marathi +
                "\n" +
                data.question_type_link_marathi}
          </Typography>
        )}
        {data.question_type_text_assamese && (
          <Typography>
            🇮🇳 Assamese: {data.question_type_text_assamese}
          </Typography>
        )}
        {data.question_type_text_bengali && (
          <Typography>🇮🇳 Bengali: {data.question_type_text_bengali}</Typography>
        )}

        {/* Options */}
        <Typography variant="h6" sx={{ mt: 2 }}>
          Options:
        </Typography>

        {["a", "b", "c", "d"].map((option) => {
          const optionTexts = [
            {
              label: "🇬🇧 English",
              value:
                data[`option_${option}_type`] == 1
                  ? data[`option_${option}_type_text_english`]
                  : data[`option_${option}_type`] == 2
                  ? data[`option_${option}_type_link_english`]
                  : data[`option_${option}_type_text_english`] +
                    "\n" +
                    data[`option_${option}_type_link_english`],
            },
            {
              label: "🇮🇳 Hindi",
              value:
                data[`option_${option}_type`] == 1
                  ? data[`option_${option}_type_text_hindi`]
                  : data[`option_${option}_type`] == 2
                  ? data[`option_${option}_type_link_hindi`]
                  : data[`option_${option}_type_text_hindi`] +
                    "\n" +
                    data[`option_${option}_type_link_hindi`],
            },
            {
              label: "🇮🇳 Marathi",
              value:
                data[`option_${option}_type`] == 1
                  ? data[`option_${option}_type_text_marathi`]
                  : data[`option_${option}_type`] == 2
                  ? data[`option_${option}_type_link_marathi`]
                  : data[`option_${option}_type_text_marathi`] +
                    "\n" +
                    data[`option_${option}_type_link_marathi`],
            },
            {
              label: "🇮🇳 Assamese",
              value: data[`option_${option}_type_text_assamese`],
            },
            {
              label: "🇮🇳 Bengali",
              value: data[`option_${option}_type_text_bengali`],
            },
          ];

          const hasValues = optionTexts.some((opt) => opt.value);

          return hasValues ? (
            <Box
              key={option}
              sx={{ mt: 2, p: 2, bgcolor: "#f5f5f5", borderRadius: 1 }}
            >
              <Typography variant="h6">Option {option}:</Typography>
              {optionTexts.map((opt, index) =>
                opt.value ? (
                  <Typography key={index}>
                    {opt.label}: {opt.value}
                  </Typography>
                ) : null
              )}
            </Box>
          ) : null;
        })}
        {/* Answer */}
        <Typography variant="h6" sx={{ mt: 2 }}>
          ✅ Answer: {data.answer}
        </Typography>
        <div
          className="col-md-12 mt-4"
          style={{
            display: "flex",
            justifyContent: "end",
          }}
        >
          <Button variant="contained" color="primary" onClick={handleClose}>
            Close
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default ViewQuestionData;
